// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__28yTx","footer":"Form_footer__2A1Mz"};